import TagManager from "react-gtm-module";

declare global {
  interface Window {
    dataLayer: Array<any>;
  }
}

export const DTLayer = (() => {
  const dispatch = (event: string, dataLayer: Object) => {
    if (self.status === "initialized")
      window.dataLayer.push({
        event,
        ...dataLayer,
      });
  };

  const self: {
    status: string;
    gtmId: string | null;
    dispatch: typeof dispatch;
  } = {
    status: "pending",
    gtmId: null,

    // Functions
    dispatch,
  };

  return self;
})();

export default function createDataLayer(gtmId: string) {
  console.log("Datalayer: Inited");

  const tagManagerArgs = {
    gtmId,
    dataLayer: {
      env: import.meta.env.DEV ? "local" : "production",
    },
  };

  TagManager.initialize(tagManagerArgs);

  // Update Object
  DTLayer.status = "initialized";
  DTLayer.gtmId = gtmId;
}
